import { Component, OnInit, Input } from '@angular/core';
import { environment as paramsG } from 'src/environments/environment';

@Component({
  selector: 'app-single-beneficios',
  templateUrl: './single-beneficios.component.html',
  styleUrls: ['./single-beneficios.component.scss']
})
export class SingleBeneficiosComponent implements OnInit {
  @Input('data') public data: any;
  public urlBaseS3: any = (<any>paramsG).api.s3;
  constructor() { }

  ngOnInit() {
  }

}
